<div id="delete-confirm-dialog">
  <div mat-dialog-container>
    <div class="content">
      <div class="dialog-header">
        <span class="dialog-title">{{
          'PROFILE.IMAGETITLECONFIRMDELETE' | translate
        }}</span>
      </div>
      <div class="dialog-container">
        <div class="confirmation">
          <span>{{ 'PROFILE.CONFIRMDELETETEXT1' | translate }}</span>
          <br />
          <span>{{ 'PROFILE.CONFIRMDELETETEXT2' | translate }}</span>
        </div>
        <div mat-dialog-actions class="btn-container">
          <button
            mat-raised-button
            class="mat-warn"
            (click)="data.isSelf ? deleteImageSelf() : deleteImage()">
            {{ 'GENERAL.CONFIRM' | translate }}
          </button>
          <button mat-button [mat-dialog-close]="data.selectedFileUrl">
            {{ 'GENERAL.CANCEL' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
